/* eslint-disable camelcase */
import { useMemo } from "react"
import {
  MaterialReactTable,
  // createRow,
  useMaterialReactTable,
} from "material-react-table"
import { createTheme, ThemeProvider, useTheme, Box, IconButton, Tooltip } from "@mui/material"
import { esES } from "@mui/material/locale"
import { MRT_Localization_ES } from "material-react-table/locales/es"
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye"
import { useNavigate } from "react-router-dom"

const CustomTable = ({ fetchedInfo, isLoadingInfoError, isLoadingInfo, isFetchingInfo, columnsTable = [] }) => {
  const navigate = useNavigate()

  const columns = useMemo(
    () =>
      columnsTable.map((column) => ({
        ...column,
      })),
    [],
  )

  const table = useMaterialReactTable({
    columns,
    data: fetchedInfo,
    // enableRowSelection: true,
    enableEditing: true,
    enableRowActions: true,
    localization: { ...MRT_Localization_ES },
    muiToolbarAlertBannerProps: isLoadingInfoError
      ? {
          color: "error",
          children: "Error en cargar los datos",
        }
      : undefined,
    muiTableContainerProps: {
      sx: {
        minHeight: "500px",
      },
    },

    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: "flex", gap: "1rem" }}>
        <Tooltip title="Ver">
          <IconButton
            onClick={() => {
              navigate(`ver`, {
                state: row?.original,
              })
            }}
          >
            <RemoveRedEyeIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),
    state: {
      isLoading: isLoadingInfo,
      showAlertBanner: isLoadingInfoError,
      showProgressBars: isFetchingInfo,
    },
  })

  return (
    <>
      <MaterialReactTable table={table} />
    </>
  )
}

const DatagridAllEgresos = (params) => {
  const theme = useTheme()
  return (
    <div>
      <ThemeProvider theme={createTheme(theme, esES)}>
        <CustomTable {...params} />
      </ThemeProvider>
    </div>
  )
}

export default DatagridAllEgresos
